import { Component, Input, OnInit } from '@angular/core';
import { PresenceInfo, PresenceType } from '@app/shared/services/pusher/pusher.service';

@Component({
  selector: 'app-active-user-avatar',
  templateUrl: './active-user-avatar.component.html'
})
export class ActiveUserAvatarComponent implements OnInit {
  @Input() user!: PresenceInfo;
  @Input() size?: 'small' | 'medium' | 'large' = 'medium';
  @Input() tooltipText?: string;

  initials: string = '';

  // For component access to enum
  PresenceType = PresenceType;

  constructor() {}

  ngOnInit(): void {
    this.generateInitials();
    if (!this.tooltipText) {
      this.generateTooltipText();
    }
  }

  private generateInitials(): void {
    console.log(this.user);
    if (!this.user || (!this.user.first_name && !this.user.last_name)) {
      this.initials = '?';
      return;
    }

    const firstInitial = this.user.first_name ? this.user.first_name.charAt(0).toUpperCase() : '';
    const lastInitial = this.user.last_name ? this.user.last_name.charAt(0).toUpperCase() : '';

    this.initials = lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
  }

  private generateTooltipText(): void {
    if (!this.user) {
      this.tooltipText = 'Unknown user';
      return;
    }

    let activity: string;

    switch (this.user.type) {
      case PresenceType.InboxViewingThreadList:
        activity = 'browsing threads';
        break;
      case PresenceType.InboxViewingThread:
        activity = 'viewing this thread';
        break;
      case PresenceType.InboxTypingMessage:
        activity = 'typing a message';
        break;
      default:
        activity = 'online';
    }

    this.tooltipText = `${this.user.first_name} is ${activity}`;
  }

  // Returns the time elapsed since the presence update in a human-readable format
  getTimeElapsed(): string {
    if (!this.user || !this.user.created_at) {
      return '';
    }

    const now = Date.now();
    const elapsed = now - this.user.created_at.getTime();

    if (elapsed < 60000) { // less than 1 minute
      return 'just now';
    } else if (elapsed < 3600000) { // less than 1 hour
      const minutes = Math.floor(elapsed / 60000);
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (elapsed < 86400000) { // less than 1 day
      const hours = Math.floor(elapsed / 3600000);
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else {
      const days = Math.floor(elapsed / 86400000);
      return `${days} day${days > 1 ? 's' : ''} ago`;
    }
  }
}
